import React from "react";
import DarkModeIcon from "../../asset/theme/DarkTheme";
import LightModeIcon from "../../asset/theme/LightTheme";

const THEME_KEY = {
    DARK: "dark",
    LIGHT: "light"
};

const THEME_LABEL = {
    [THEME_KEY.DARK]: "Light Mode",
    [THEME_KEY.LIGHT]: "Dark Mode",
};

const ICON_THEME_MAP = {
    [THEME_KEY.DARK]: <LightModeIcon />,
    [THEME_KEY.LIGHT]: <DarkModeIcon />
};

export {
    ICON_THEME_MAP,
    THEME_KEY,
    THEME_LABEL
};
